import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

export const StyledSubtitleContainer = styled.div`
  display: flex;
  padding: 16px 0;
  height: fit-content;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const StyledTooltip = styled.div`
  display: flex;
  align-items: flex-start;
`

export const StyledTopicPivotDescription = styled.div`
  display: flex;
  align-items: flex-start;
`

interface StyledTopicPivotNameProps {
  mode: Theme
  testId: string
  hasMaxWidth?: boolean
}

export const StyledTopicPivotName = styled.div.attrs<StyledTopicPivotNameProps>((prop) => ({
  [AUTO_ATTR_KEY]: prop.testId
}))<StyledTopicPivotNameProps>`
  display: flex;
  align-items: center;
  color: ${({ mode }) => sys[mode].text.primary};
  font-size: ${sys.typescale[16].size};
  font-weight: ${sys.fontWeight.medium};
  line-height: ${sys.typescale[16].lineHeight};
  /* line-clamp */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  max-width: ${({ hasMaxWidth }) => (hasMaxWidth ? '297px' : 'none')};
  overflow: hidden;
`

export const StyledVersus = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.insightModal.vs
})<{
  mode: Theme
}>`
  color: ${({ mode }) => sys[mode].text.placeholder};
  font-size: ${sys.typescale[16].size};
  font-weight: ${sys.fontWeight.medium};
  line-height: ${sys.typescale[16].lineHeight};
  /* line-clamp */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: keep-all;
`
